import React from 'react';
import EditableTable from 'src/views/admin/EditableTable';
import {ColumnSettings} from 'src/views/admin/EditableTable/types';
import CheckedValue from 'src/views/admin/CheckedValue';
import UniversityDropdown from '../UniversityDropdown';
import {useField} from 'formik';

const UniversitySelection = () => {
  const [field, , helpers] = useField('universityId');

  return (
    <UniversityDropdown
      autoSelectFirstUniversity
      value={field.value}
      onChange={helpers.setValue}
      hideLabel
    />
  );
};

const columns: ColumnSettings[] = [
  {
    name: 'name',
    title: 'Name',
    sortable: true,
  },
  {
    name: 'alias',
    title: 'Alias',
    sortable: true,
  },
  {
    name: 'tenantId',
    title: 'Tenant Id',
    sortable: true,
  },
  {
    name: 'tenantDomain',
    title: 'Tenant Domain',
    sortable: true,
  },
  {
    name: 'universityId',
    title: 'University',
    sortable: true,
    renderValue: (_, record) => record.universityName || '-',
    FormField: UniversitySelection,
  },
  {
    name: 'headerKitDomain',
    title: 'Header Kit Domain',
  },
  {
    name: 'samlIdpMetadataDomain',
    title: 'SAML IdP Metadata Domain',
  },
  {
    name: 'autoProvisionUsers',
    title: 'Auto provision users?',
    type: 'checkbox',
    renderValue: CheckedValue,
  },
];

const ExperienceEverywhereTenants = (): React.ReactElement => (
  <div className="mb-24 ml-64 mr-64">
    <h1 className="shared-font headline">Experience Everywhere Tenants</h1>
    <EditableTable
      basePath="/v1/admin/experience-everywhere-tenants"
      defaultSortKey="name"
      columns={columns}
      identifier="experience-everywhere-tenants"
    />
  </div>
);

export default ExperienceEverywhereTenants;
